import { InternalServerError, NotFoundError } from './errors'

export const fetchData = <TData, TVariables>(
  passedUrl: string,
  query: string,
  variables?: TVariables,
  options?: RequestInit['headers'],
): (() => Promise<TData>) => {
  // console.log(passedUrl)
  // console.log(query)
  // console.log(variables)
  // console.log(options)

  // Transient failures (Pimcore blip, network, 5xx) must not fall through as a single
  // attempt — a lone failure during ISR regeneration otherwise gets cached as a 404.
  // Retry a few times with a short backoff; a genuine NotFound is not retried.
  const MAX_ATTEMPTS = 3

  return async () => {
    let lastError: unknown
    for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
      try {
        const res = await fetch(passedUrl, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            ...options,
          },
          body: JSON.stringify({
            query,
            variables,
          }),
        })

        if (!res.ok) {
          throw new InternalServerError(`HTTP ${res.status} ${res.statusText}`)
        }

        const json = await res.json()

        if (json.errors) {
          const { message } = json.errors[0] || ''
          // TODO: [AC-407] doesn't handle bad user input
          if (typeof message === 'string' && message.endsWith('could not be found')) {
            throw new NotFoundError(message || 'NotFoundError')
          } else {
            throw new InternalServerError(message || 'InternalServerError')
          }
        }

        return json.data
      } catch (error) {
        // A genuine 404 is a stable answer — don't waste retries on it.
        if (error instanceof NotFoundError) throw error
        lastError = error
        if (attempt < MAX_ATTEMPTS) {
          await new Promise((resolve) => setTimeout(resolve, attempt * 300))
        }
      }
    }

    console.error('Error occured while fetching data after retries:', lastError)
    throw lastError
  }
}
